import { makeEntityId } from '@web-platform/shared-universal-types-utils/src/utils';

import type {
  RadarItinerary,
  RadarLeg,
  RadarSegment,
} from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarItineraryTypes';
import type { Segment } from '@web-platform/shared-universal-types/src/redux/state/entities/flights/segments';

export const mapRadarSegments = (itineraries: RadarItinerary[]): Segment[] => {
  const segmentIdsMap = new Map();
  const segments: Segment[] = [];
  itineraries.forEach((itinerary: RadarItinerary) => {
    itinerary.legs.forEach((leg: RadarLeg) => {
      leg.segments.forEach((segment: RadarSegment) => {
        if (!segmentIdsMap.get(segment.id)) {
          segments.push({
            arrival: segment.arrival,
            departure: segment.departure,
            destination_place_id: segment.destination.flightPlaceId,
            destination_entity_id: makeEntityId(segment.destination.entityId),
            duration: segment.durationInMinutes,
            id: segment.id,
            marketing_carrier_id: segment.marketingCarrier.id,
            marketing_flight_number: segment.flightNumber,
            operating_carrier_id: segment.operatingCarrier.id,
            origin_place_id: segment.origin.flightPlaceId,
            origin_entity_id: makeEntityId(segment.origin.entityId),
          });
          segmentIdsMap.set(segment.id, true);
        }
      });
    });
  });
  return segments;
};
